import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7414a03c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page page-alerts-history page-table" }
const _hoisted_2 = {
  key: 0,
  class: "page-table-body"
}
const _hoisted_3 = { class: "table-main-wrapper" }
const _hoisted_4 = { class: "table-main" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "日時"),
    /*#__PURE__*/_createElementVNode("th", null, "タイトル"),
    /*#__PURE__*/_createElementVNode("th", { class: "control-cell" })
  ])
], -1))
const _hoisted_6 = { class: "control-cell" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "編集", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "controls" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-new" }, "新規追加", -1))

import { ref, onMounted } from 'vue'
import ControllPanel from '@/components/common/ControllPanel.vue'
import News from '@/models/News'
import { useInitDataStore } from '@/stores/initDataStore'
import { useNewsHistoryStore } from '@/stores/newsStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const fetched = ref<boolean>(false)
const news = ref<News | undefined>()
const date = ref(new Date())
const initDataStore = useInitDataStore()
const newsHistoryStore = useNewsHistoryStore()

onMounted(async () => {
  await fetch(date.value)
  fetched.value = true
})

const fetch = async (d: Date) => {
  const notificationId = initDataStore.initData.systemInfo.notification.id

  if (notificationId === undefined) {
    return
  }

  date.value = d
  news.value = await newsHistoryStore.history(d)
}

const handleDelete = async (id?: number) => {
  if (!id) {
    return
  }

  if (!confirm('削除します。よろしいですか？')) {
    return
  }

  await newsHistoryStore.delete(id)

  alert('削除しました。')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ControllPanel, {
      onChangeDate: fetch,
      "default-resolution": "month",
      "show-resolution": false,
      class: "flex-center bg-gray"
    }),
    (fetched.value && news.value?.items.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value?.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.formatTime()), 1),
                    _createElementVNode("td", null, _toDisplayString(item.title), 1),
                    _createElementVNode("td", _hoisted_6, [
                      _createVNode(_component_router_link, {
                        to: `/settings/information/edit/${item.id}`
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (handleDelete(item.id)),
                        class: "btn"
                      }, "削除", 8, _hoisted_8)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, { to: "/settings/information/edit" }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ]))
}
}

})